

import Vue from 'vue';
import fb from '@/store/gobi-mw-firestore';

import { GdbView } from '@/views/GdbView.vue';
declare module '@/views/GdbView.vue' {
	interface GdbView extends Vue {
		accountId?: string,
		gdbid?: string,
		data: any;
	}
}

let db: firebase.firestore.Firestore;
let functions: firebase.functions.Functions;

export class GdbState {

	public view: GdbView | null = null;

	public accountId?: string;
	public gdbid?: string;

	private _unsubscribeListenToGdb: (() => void) | null = null;

	constructor(view: GdbView) {
		db = fb.db!;
		functions = fb.functions!;

		this.view = view;

		this.view.data = 'haha';
	}




}
